import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid , Header , Image , Table, Icon } from 'semantic-ui-react';
import ThemeColorSetting from '../../constants/themeColor';
import macBook from '../../assets/macBook.gif';
import topoGraphy from "../../assets/pattern/topography.svg";

const styles = {
  coverContainer : {
		padding :'10vh 0',
    backgroundImage: 'url(' +topoGraphy+ ')',
		backgroundColor: ThemeColorSetting.white,
		backgroundSize : '500px 500px',
		backgroundRepeat : 'repeat'
  },
  descriptionWrapper : {
    display : 'flex' ,
    flexDirection : 'column',
    justifyContent : 'center',
    padding : '5vh'
  },
  description : {
    fontSize : '20px',
    color : ThemeColorSetting.paragrapgh,
    lineHeight: '200%'
  },
  imageWrapper : {
    display : 'flex',
    alignItems : 'center',
    justifyContent : 'center',
    padding : '8vh 0'
  },
  deviceWrapper : {
    width : '80vh',
    height : '100px',
    backgroundImage: 'url(' + macBook + ')',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat'
  },
  header : {
    color : ThemeColorSetting.black,
    fontSize : '50px'
  }
}

class Pitch3 extends Component {
  render() {
    const { string } = this.props;
    return(
      <Grid.Row columns='2' style={styles.coverContainer}>
        <Grid.Column style={styles.imageWrapper}>
          <Image src={macBook}/>
        </Grid.Column>
        <Grid.Column style={styles.descriptionWrapper}>
          <Header as='h1' style={styles.header}>{string['pich3Header']}</Header>
          <p style={styles.description}>{string['pitch3Content']}</p>
					<Table basic='very' celled>
					 <Table.Body>
						 <Table.Row textAlign='center'>
							 <Table.Cell>
								<Header as='h3' icon color='grey'>
									<Icon name='time' />
									{string['realTimePerf']}
								</Header>
							 </Table.Cell>
							 <Table.Cell>
								<Header as='h3' icon color='grey'>
									<Icon name='file excel outline' />
									{string['csvDownload']}
								</Header>
							 </Table.Cell>
							 <Table.Cell>
								<Header as='h3' icon color='grey'>
									<Icon name='cloud' />
									{string['cloudStorage']}
								</Header>
							 </Table.Cell>
							</Table.Row>
						</Table.Body>
					</Table>
        </Grid.Column>
      </Grid.Row>
    )
  }
}

function mapStateToProps(state) {
  return {
    string : state.preference.string
  }
}

export default connect(mapStateToProps,null)(Pitch3)



/** WEBPACK FOOTER **
 ** ./src/containers/pitch/webAppPitch.js
 **/